import React from 'react';
import {
    TextInput,
    DateInput,
    SelectInput,
    SimpleForm,
    Edit,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Notification,
    BooleanInput
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import allStates from '../donors/AllStates';
import jwt_decode from 'jwt-decode';
import Sign from '../controls/Signature';
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

var phySign = null;
var donorSign = null;
var data = null;

let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';
const editStyles = {
    root: {
        alignItems: 'flex-start'
    },
    table: {
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        textAlign: 'left',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0px',
    },
    tableBorder: {
        border: '2px',
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        textAlign: 'left',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0px',
    },
    hr:{
        width: '100%',
    },
    hide:{
        display: 'none'
    }
};

const Match = [
    {
            id : 'Match Found',
            name: 'Match Found'
    },
    {
            id: 'Not Found',
            name: 'Not Found'
    }
]

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const EditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={`/registration?filter=%7B"branch_code"%3A"${branch_code}"%7D&order=ASC&page=1&perPage=25&sort=name`} label='Registration List'/>
    </CardActions>
);

const genderValues = [
    {
        id: 'Male',
        name: 'Male'
    },
    {
        id: 'Female',
        name: 'Female'
    },
    {
        id: 'Other',
        name: 'Other'
    }
]

const YesNoExt = [
    {
        id: 'Yes',
        name: 'Yes'
    },
    {
        id : 'No',
        name: 'No'
    },
    {
        id : 'I am Male',
        name: 'I am Male'
    }
  ]

  const YesNo = [
    {
        id: 'Yes',
        name: 'Yes'
    },
    {
        id : 'No',
        name: 'No'
    }
  ]

const RegistrationToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            transform={data => ({ ...data, donor_sign: donorSign,  physician_sign: phySign })}
            submitOnEnter={false}
            id="save"
        />
    </Toolbar>
);


const setPhySignatureValue=(image)=>{
    phySign = image;
    //console.log(donorSing);
}

const setDonSignatureValue=(image)=>{
    donorSign = image;
    //console.log(donorSing);
}


const SetData=({record})=>(
    data = record,
    <div></div>
)

const RegistrationEdit = ({ classes, ...props }) => (
    <ErrorBoundary>
        <Edit title='Update Registration' {...props} actions={<EditActions/>}>
            <SimpleForm toolbar={<RegistrationToolbar />}>
                <SetData />
            <Table style={{ margin: 'auto',  fontSize:'12px', cellspacing:"0", borderWidth:"1", width:"100%"}} >
                <TableBody  >
                    <TableRow>
                        <TableCell colSpan="3">
                            <h2 style={{color:'navy', textAlign:'center'}}>APPLICANT / NEW DONOR QUESTIONNAIRE</h2>
                        </TableCell>
                    </TableRow>
                    <TableRow >
                            <TableCell  ><SanitizedTextInput source="f_name"   label="First Name" validate={required()}/></TableCell  >
                            <TableCell  ><SanitizedTextInput source="m_name"   label="Middle Initial" /></TableCell>
                            <TableCell  ><SanitizedTextInput source="l_name"   label="Last Name" validate={required()} /></TableCell  >
                    </TableRow>

                    <TableRow>
                        <TableCell  ><SanitizedTextInput source="apt"   label="Apt/Suit#" /></TableCell>
                        <TableCell  ><SanitizedTextInput source="street"   label="Street" validate={required()} /></TableCell>
                        <TableCell  ><SanitizedTextInput source="city"   label="City" validate={required()}/></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell  ><TextInput source="zip"    label="Zip" validate={required()} /></TableCell>
                        <TableCell  ><SelectInput source="state"  label="State" validate={required()} choices={allStates}/></TableCell>
                        <TableCell  ><SelectInput source="gender" lable="Gender"  choices={genderValues} validate={required()} /></TableCell>

                    </TableRow>
                    <TableRow>
                        <TableCell  ><TextInput source="don_ph"  label="Phone" validate={required()} /></TableCell>
                        <TableCell  ><TextInput source="email"  label="Email" validate={required()} /></TableCell>
                        <TableCell  ><TextInput source="about_us"  label="How did you hear about us? " validate={required()} /></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan="3">
                        <table className={classes.table} border="1" cellSpacing="2px" cellPadding="5px">
                            <tbody>
                                <tr>
                                    <td>HAVE YOU HAD ANY EAR OR BODY PIERCINGS, TATTOO OR ANY TATTOO TOUCH-UPS IN THE PAST 12 MONTHS?</td>
                                    <td><SelectInput choices={YesNo} source="tattoo_12"  label="" /></td>
                                    <td>Date of Last Piercing/Tattoo/Touch-Up:<DateInput source="tattoo_12_date"    label=""  locales="en-us"/> </td>
                                </tr>
                                <tr>
                                    <td>HAVE YOU BEEN IN JAIL OR PRISON DURING THE LAST 12 MONTHS FOR A PERIOD GREATER THAN 72 HOURS?</td>
                                    <td><SelectInput choices={YesNo} source="jail_72" label=""  /></td>
                                    <td>Date of Release:<DateInput source="release_date"    label=""  locales="en-us"/> </td>
                                </tr>
                                <tr>
                                    <td>DID YOU EAT SOMETHING WITHIN THE LAST 4 HOURS?</td>
                                    <td><SelectInput choices={YesNo} source="eat_4"  label="" /></td>
                                    <td>What:<TextInput source="eat_what"  label="" /></td>
                                </tr>
                                <tr>
                                    <td>HAVE YOU EVER HAD ANY SURGERY? </td>
                                    <td><SelectInput choices={YesNo} source="surgery" label=""  /></td>
                                    <td>Date of last Surgery:<DateInput source="surgery_date"    label=""  locales="en-us"/> </td>
                                </tr>
                                <tr>
                                    <td>IF FEMALE:  HAVE YOU BEEN PREGNANT WITHIN THE PAST 12 MONTHS?</td>
                                    <td><SelectInput choices={YesNoExt} source="pregnant_12"  label="" /></td>
                                    <td>Date of Last Pregnancy:<DateInput source="pregnant_date"    label=""  locales="en-us"/> </td>
                                </tr>
                                <tr>
                                    <td>HAVE YOU DONATED PLASMA OR BLOOD IN THE PAST? </td>
                                    <td><SelectInput choices={YesNo} source="donated_plasma" label=""  /></td>
                                    <td>When:<DateInput source="donated_date"    label=""  locales="en-us"/><br/>
                                        Where:<TextInput source="donated_where" label="" /> </td>
                                </tr>
                                <tr>
                                    <td>DO YOU HAVE A PROSTHETIC LIMB? </td>
                                    <td><SelectInput choices={YesNo} source="limb" label=""  /></td>
                                    <td>Body Part:<TextInput source="body_part" label="" /></td>
                                </tr>
                                <tr>
                                    <td>DO YOU TAKE ANY MEDICATIONS?<font size="8px">(Include non-prescription / over-the-counter meds in your response).</font></td>
                                    <td><SelectInput choices={YesNo} source="medications"  label="" /></td>
                                    <td>List of Medications:<TextInput source="medications_list" rowsMax={4} multiline    label=""  /> </td>
                                </tr>
                            </tbody>
                        </table>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>DONOR SIGNATURE :</TableCell>
                        <TableCell> <Sign   setSignatureValue={setDonSignatureValue}  url={data?data.donor_signature: null} /></TableCell  >
                        <TableCell><DateInput source="sign_date"    label="DATE"  locales="en-us"/> </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
                <hr className={classes.hr} />
                <table className={classes.table} border="0" cellSpacing="2px" cellPadding="5px">
                <tbody>
                    <tr>
                        <td colSpan="6"> <h3 style={{color:'navy', textAlign:'center'}}>FOR CENTER STAFF USE ONLY</h3> </td>
                    </tr>
                    <tr>
                        <td>PS FOLLOW-UP NEEDED:</td>
                        <td><SelectInput choices={YesNo} source="follow_up"  label="" /></td>
                        <td>HEALTH HISTORIAN INITIALS:</td>
                        <td><TextInput source="hist_init"  label="" /></td>
                        <td>Date:</td>
                        <td><DateInput source="hist_init_date"    label=""  locales="en-us"/></td>
                    </tr>
                    <tr>
                        <td>DEFERRAL CARD FILE CHECK:</td>
                        <td><SelectInput choices={Match} source="def_check"  label="" /></td>
                        <td>INITIALS:</td>
                        <td><TextInput source="def_check_init"  label="" /></td>
                        <td>Date:</td>
                        <td><DateInput source="def_check_date"    label=""  locales="en-us"/></td>
                    </tr>
                    <tr>
                        <td>UNACCEPTABLE ADDRESS LIST CHECK:</td>
                        <td><SelectInput choices={Match} source="address_check"  label="" /></td>
                        <td>INITIALS:</td>
                        <td><TextInput source="addr_check_init"  label="" /></td>
                        <td>Date:</td>
                        <td><DateInput source="addr_check_date"    label=""  locales="en-us"/></td>
                    </tr>
                    <tr>
                        <td colSpan="6">VEIN ASSESSMENT</td>
                    </tr>
                    <tr>
                        <td><u>LEFT ARM</u>:   Green:</td>
                        <td><SelectInput choices={YesNo} source="vein_left_g"  label="" /></td>
                        <td>Yellow:</td>
                        <td><SelectInput choices={YesNo} source="vein_left_y"  label="" /></td>
                        <td>Red:</td>
                        <td><SelectInput choices={YesNo} source="vein_left_r"  label="" /></td>
                    </tr>
                    <tr>
                        <td><u>RIGHT ARM</u>:   Green:</td>
                        <td><SelectInput choices={YesNo} source="vein_right_g"  label="" /></td>
                        <td>Yellow:</td>
                        <td><SelectInput choices={YesNo} source="vein_right_y"  label="" /></td>
                        <td>Red:</td>
                        <td><SelectInput choices={YesNo} source="vein_right_r"  label="" /></td>
                    </tr>
                    <tr>
                        <td colSpan="3">VEIN ASSESSMENT PERFORMED BY INITIALS:</td>
                        <td><TextInput source="vein_init"  label="" /></td>
                        <td>Date:</td>
                        <td><DateInput source="vein_date"    label=""  locales="en-us"/></td>
                    </tr>
                    <tr>
                        <td>COMMENTS (IF APPLICABLE):</td>
                        <td colSpan="5"><TextInput source="comments"   rowsMax={4} multiline fullWidth  label=""/></td>
                    </tr>
                </tbody>
                </table>

                <hr className={classes.hr} />
                <table className={classes.table} border="1" cellSpacing="2px" cellPadding="5px">
                <tbody>
                    <tr>
                        <td>
                        <table className={classes.table} cellSpacing="2px" cellPadding="5px">
                        <tbody>
                            <tr>
                                <td colSpan="2"> <h4 style={{color:'navy', textAlign:'center'}}>PHYSICIAN SUBSTITUTE EVALUATION (IF APPLICABLE):</h4> </td>
                            </tr>
                            <tr>
                                <td colSpan="2"><TextInput source="phy_eval"   rowsMax={4} multiline fullWidth  label="Physician substitute comments"/> </td>
                            </tr>
                            <tr>
                                <td>
                                <Sign   setSignatureValue={setPhySignatureValue}  url={data?data.phy_sign:null} />
                                </td>
                                <td><DateInput source="phy_date"    label="Date"  locales="en-us"/>
                                    <TextInput  source="modified_by" className={classes.hide}  label="" defaultValue={((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).user_name : null }/>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                        </td>
                    </tr>
                </tbody>
                </table>
                <Table>
                    <TableBody>
                    <TableRow>
                        <TableCell><BooleanInput source="is_approved" label="Is Approved?" /></TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
            </SimpleForm>

        </Edit>
    </ErrorBoundary>
);

export default withStyles(editStyles)(RegistrationEdit);